/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Chandima Sooriyaarachchi",
  title: "Hi all, I'm Chandima Sooriyaarachchi",
  subTitle: emoji(
    `Computer Science Graduate 🚀 With a strong background in software engineering, specializing in JavaScript, React.js, Node.js, and React Native, I have experience working with various modern libraries and frameworks.\nAlongside my development expertise, I’ve gained hands-on experience as a DevOps Engineer, where I focused on automation and improving software delivery processes. My diverse technical skills and real-world engineering experience allow me to craft scalable and efficient solutions for complex challenges.`
  ),
  resumeLink:
    "https://drive.google.com/file/d/1j7NTIioffe48Nt5_ZTNNN3KnJFmmIyQ6/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};


// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/chandima-dev",
  linkedin: "https://www.linkedin.com/in/chandimasooriyaarachchi/",
  gmail: "sanjusooriyaarachchi@gmail.com",
  // gitlab: "https://gitlab.com/saadpasta",
  facebook: "https://www.facebook.com/profile.php?id=100007044557312",

  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I have experienced",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
   
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

softwareSkills: [
  {
    skillName: "HTML5",
    fontAwesomeClassname: "fab fa-html5"
  },
  {
    skillName: "CSS3",
    fontAwesomeClassname: "fab fa-css3-alt"
  },
  {
    skillName: "Sass",
    fontAwesomeClassname: "fab fa-sass"
  },
  {
    skillName: "JavaScript",
    fontAwesomeClassname: "fab fa-js"
  },
  {
    skillName: "React",
    fontAwesomeClassname: "fab fa-react"
  },

  {
    skillName: "Node.js",
    fontAwesomeClassname: "fab fa-node"
  },
  {
    skillName: "Python",
    fontAwesomeClassname: "fab fa-python"
  },
  {
    skillName: "Java",
    fontAwesomeClassname: "fab fa-java"
  },
  {
    skillName: "SQL Database",
    fontAwesomeClassname: "fas fa-database"
  },
  {
    skillName: "AWS",
    fontAwesomeClassname: "fab fa-aws"
  },
  {
    skillName: "Firebase",
    fontAwesomeClassname: "fas fa-fire"
  },
  {
    skillName: "Docker",
    fontAwesomeClassname: "fab fa-docker"
  },
  // {
  //   skillName: "Kubernetes",
  //   fontAwesomeClassname: "fab fa-kubernetes"
  // },
  {
    skillName: "GCP",
    fontAwesomeClassname: "fab fa-google"
  },
  {
    skillName: "Azure",
    fontAwesomeClassname: "fab fa-microsoft"
  },
  // {
  //   skillName: "Datadog",
  //   fontAwesomeClassname: "fab fa-datadog"
  // },
  // {
  //   skillName: "Grafana",
  //   fontAwesomeClassname: "fab fa-grafana"
  // },
  {
    skillName: "DevOps",
    fontAwesomeClassname: "fas fa-cogs" // or use "fab fa-dev" if available
  },
  {
    skillName: "SonarCloud",
    fontAwesomeClassname: "fas fa-shield-alt"
  },
  {
    skillName: "CI/CD",
    fontAwesomeClassname: "fas fa-rocket"
  },
  {
    skillName: "GitHub",
    fontAwesomeClassname: "fab fa-github"
  },  
  {
    skillName: "Android Studio",
    fontAwesomeClassname: "fab fa-android"
  },  
  {
    skillName: "Jenkins",
    fontAwesomeClassname: "fab fa-jenkins"
  },
  // {
  //   skillName: "Postman",
  //   fontAwesomeClassname: "fab fa-postman"
  // },
  {
    skillName: "Bootstrap",
    fontAwesomeClassname: "fab fa-bootstrap"
  },
  {
    skillName: "Laravel",
    fontAwesomeClassname: "fab fa-laravel"
  },
  {
    skillName: "npm",
    fontAwesomeClassname: "fab fa-npm"
  },
  {
    skillName: "Swift",
    fontAwesomeClassname: "fab fa-swift"
  }
],

  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Sri Lanka Institute of Information Technology",
      logo: require("./assets/images/sliit2.jpg"),
      subHeader: "Bachelor of Science Degree, Second Class Lower Division (Honours)",
      duration: "September 2020 - september 2024",
      desc: "CGPA - 3.14",
      descBullets: [
        "Introduction to Programming , Computer Systems , Visual Programming , Graph Theory , Linear Algebra",
        "Object Oriented Programming , Data Structures and Algorithms , Software Engineering , Database Management Systems , Web Development",
        "Machine Learning , Deep Learning , DevOps, DevSecOps, IOT"
      ]
    },
    {
      schoolName: "Dudley Senanayake Central College, Tholangamuwa",
      logo: require("./assets/images/dscc.jpg"),
      subHeader: "High School",
      duration: "February 2010 - August 2018",
      desc: "Completed Advanced Level Within Physical Science Scream ",
      descBullets: ["Combined Mathematics, Physics, Chemistry "]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Programming Language ( Java, JavaScript, Python, PHP, SQL )", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Frameworks / Libraries (React.js, TypeScript, Next.js, Laravel, Express.js, Node.js )",
      progressPercentage: "90%"
    },
    {
      Stack: "Styling ( CSS, Bootstrap, SaaS, React-MUI )",
      progressPercentage: "90%"
    },
     {
      Stack: "Databases ( MongoDB, MySQL, Oracle, Firebase, SQLite )", //Insert stack or technology you have experience in
      progressPercentage: "80%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Cloud Platforms ( AWS: EC2, S3, Serverless, ECS, ECR, Fargate, IAM Roles, GCP, Azure )",
      progressPercentage: "80%"
    },
    {
      Stack: "Methodologies and Practices ( Agile Methodology, DevSecOps Tools, SonarCloud )",
      progressPercentage: "80%"
    },
    {
      Stack: "Monitoring and Observability ( Dtadog, Grafana)",
      progressPercentage: "75%"
    },
    {
      Stack: "Development Tools and Version Control ( GitHub, GitLab, GitHub Actions, Bitbucket)",
      progressPercentage: "70%"
    },{
      Stack: "Infrastructure as Code (IaC) and Automation ( Ansible, Terraform )",
      progressPercentage: "90%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: false, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Facebook",
      companylogo: require("./assets/images/facebookLogo.png"),
      date: "June 2018 – Present",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      role: "Front-End Developer",
      company: "Quora",
      companylogo: require("./assets/images/quoraLogo.png"),
      date: "May 2017 – May 2018",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      role: "Software Engineer Intern",
      company: "Airbnb",
      companylogo: require("./assets/images/airbnbLogo.png"),
      date: "Jan 2015 – Sep 2015",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/kolamasrilanka.PNG"),
      projectName: "Kolama Web-App",
      projectDesc: "This is created for targetting tourism in Sri Lanka and they can easily find their want places for events and they can buy traditional items through this app",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://kolamasrilanka.netlify.app/"
        },{
          name: "Reactjs",
          url: "https://kolamasrilanka.netlify.app/"
        }
        ,{
          name: "Nodejs",
          url: "https://kolamasrilanka.netlify.app/"
        }
        ,{
          name: "MongoDB",
          url: "https://kolamasrilanka.netlify.app/"
        },{
          name: "Mongoose",
          url: "https://kolamasrilanka.netlify.app/"
        }
        ,{
          name: "CSS",
          url: "https://kolamasrilanka.netlify.app/"
        },{
          name: "JWT",
          url: "https://kolamasrilanka.netlify.app/"
        }
        ,{
          name: "Metireal UI ",
          url: "https://kolamasrilanka.netlify.app/"
        },
        {
          name: "Context API ",
          url: "https://kolamasrilanka.netlify.app/"
        },{
          name: "Stripe payment gate",
          url: "https://kolamasrilanka.netlify.app/"
        },
      ]
    },
    {
      image: require("./assets/images/suranimala.png"),
      projectName: "Suranimala Drone Based Solution",
      projectDesc: "This device can be used in emergency situations to transport products safely, quickly, and securely.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://suranimala.vercel.app/"
        },{
          name: "React-Native",
          url: "https://suranimala.vercel.app/"
        }
        ,{
          name: "Nodejs",
          url: "https://suranimala.vercel.app/"
        }
        ,{
          name: "machine Learning",
          url: "https://suranimala.vercel.app/"
        }
        ,{
          name: "Deep Learning",
          url: "https://suranimala.vercel.app/"
        },{
          name: "Python",
          url: "https://suranimala.vercel.app/"
        },{
          name: "Linux",
          url: "https://suranimala.vercel.app/"
        }
        ,{
          name: "Automation Scripting",
          url: "https://suranimala.vercel.app/"
        }
        ,{
          name: "IOT",
          url: "https://suranimala.vercel.app/"
        },{
          name: "TensorFlow",
          url: "https://suranimala.vercel.app/"
        },{
          name: "Keras",
          url: "https://suranimala.vercel.app/"
      },
      {
        name: "OpenCV",
        url: "https://suranimala.vercel.app/"
      },{
        name: "GitLab",
        url: "https://suranimala.vercel.app/"
      }
      ]
    },
    {
      image: require("./assets/images/devops_loop.png"),
      projectName: "CTSE DevOps",
      projectDesc: "Developed an e-commerce backend using Node.js and successfully completed it with DevOps tools and technologies.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://github.com/chandima-dev/CTSEWebApp"
        },
        {
          name: "Nodejs",
          url: "https://github.com/chandima-dev/CTSEWebApp"
        },
        {
          name: "Express",
          url: "https://github.com/chandima-dev/CTSEWebApp"
        },
        {
          name: "OAuth",
          url: "https://github.com/chandima-dev/CTSEWebApp"
        },
        {
          name: "MongoDB",
          url: "https://github.com/chandima-dev/CTSEWebApp"
        },
        {
          name: "JWT",
          url: "https://github.com/chandima-dev/CTSEWebApp"
        },
        {
          name: "AWS EC2",
          url: "https://github.com/chandima-dev/CTSEWebApp"
        },
        {
          name: "GitHub Actions",
          url: "https://github.com/chandima-dev/CTSEWebApp"
        },
        {
          name: "IAM Roles",
          url: "https://github.com/chandima-dev/CTSEWebApp"
        },
        {
          name: "ECS",
          url: "https://github.com/chandima-dev/CTSEWebApp"
        },
        {
          name: "ECR",
          url: "https://github.com/chandima-dev/CTSEWebApp"
        },
        {
          name: "Fargate",
          url: "https://github.com/chandima-dev/CTSEWebApp"
        },
        {
          name: "Docker",
          url: "https://github.com/chandima-dev/CTSEWebApp"
        },
        {
          name: "DevSecOps",
          url: "https://github.com/chandima-dev/CTSEWebApp"
        },
        {
          name: "GitHub",
          url: "https://github.com/chandima-dev/CTSEWebApp"
        }
      ]

    },
    {
      image: require("./assets/images/herbalguru.PNG"),
      projectName: "Herbalguru",
      projectDesc: "This web application is created for targeting sell medicines and herbal items there are two rolls sellers and customers on this application ",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://herbalguru.netlify.app/"
        },{
          name: "Reactjs",
          url: "https://herbalguru.netlify.app/"
        }
        ,{
          name: "Nodejs",
          url: "https://herbalguru.netlify.app/"
        }
        ,{
          name: "MongoDB",
          url: "https://herbalguru.netlify.app/"
        },{
          name: "Mongoose",
          url: "https://herbalguru.netlify.app/"
        },{
          name: "Metireal UI",
          url: "https://herbalguru.netlify.app/"
        },{
          name: "Redux",
          url: "https://herbalguru.netlify.app/"
        }
        ,{
          name: "SCSS",
          url: "https://herbalguru.netlify.app/"
        },{
          name: "JWT",
          url: "https://herbalguru.netlify.app/"
        },{
          name: "Stripe payment gate",
          url: "https://herbalguru.netlify.app/"
        },{
          name: "Microservices",
          url: "https://herbalguru.netlify.app/"
        },{
          name: "Docker",
          url: "https://herbalguru.netlify.app/"
        },
      ]
    },
    {
      image: require("./assets/images/blogapp.PNG"),
      projectName: "Blog App",
      projectDesc: "Discuss the react node and comparing with each other frameworks.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://blog-app-chandima99.netlify.app/"
        },{
          name: "Reactjs",
          url: "https://blog-app-chandima99.netlify.app/"
        }
        ,{
          name: "Nodejs",
          url: "https://blog-app-chandima99.netlify.app/"
        }
        ,{
          name: "MongoDB",
          url: "https://blog-app-chandima99.netlify.app/"
        }
        ,{
          name: "CSS",
          url: "https://blog-app-chandima99.netlify.app/"
        },{
          name: "MongoDB",
          url: "https://blog-app-chandima99.netlify.app/"
        },{
          name: "Mongoose",
          url: "https://blog-app-chandima99.netlify.app/"
        }
      ]
    },
    {
      image: require("./assets/images/chatapp.PNG"),
      projectName: "Chat-App",
      projectDesc: "This is a real-time chat application.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://chandima-chat-app.netlify.app/"
        },{
          name: "Reactjs",
          url: "https://chandima-chat-app.netlify.app/"
        }
        ,{
          name: "Nodejs",
          url: "https://chandima-chat-app.netlify.app/"
        }
        ,{
          name: "Socket",
          url: "https://chandima-chat-app.netlify.app/"
        }
        ,{
          name: "CSS",
          url: "https://chandima-chat-app.netlify.app/"
        },{
          name: "JWT",
          url: "https://chandima-chat-app.netlify.app/"
        }
      ]
    },

  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Microsoft Certified: Azure Fundamentals",
      subtitle:
        "AZ- 900 Azure Fundamentals",
      image: require("./assets/images/az-9001.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/78140f46-a068-4bd0-b10a-2b020831d477?source=linked_in_profile"
        },
      ]
    },
    {
      title: "GitHub Certified: GitHub Fundamentals",
      subtitle:
        "GitHub Fundamentals",
      image: require("./assets/images/github_certificate.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/3fea1792-3358-42ae-8f82-5434e50f05b9/public_url"
        },
      ]
    },
    {
      title: "Datadog Certified: Datadog Fundamentals",
      subtitle:
        "Datadog Learning Center",
      image: require("./assets/images/datadog.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://learn.datadoghq.com/certificates/tfabo5lqlv"
        },
      ]
    },
    
    {
      title: "Ansible Certified: LinkedIn",
      subtitle:
        "Learning Ansible",
      image: require("./assets/images/ansible.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.linkedin.com/learning/certificates/0b3e84ac9a1d88421373445637eccd7e20492644bf810f984d5e625bdc6258f4"
        },
      ]
    },
    {
      title: "Backend Development: devtown",
      subtitle:
        "Recipe API Backend Web Development Bootcamp",
      image: require("./assets/images/backend-dev.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.cert.devtown.in/verify/1CkNzP"
        },
      ]
    },
    {
      title: "Higher Diploma IN Information Technology",
      subtitle:
        "Issues from SLIIT for completed my Diploma in Information Technology.",
      image: require("./assets/images/sliitchandimaceti.jpeg"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        // {
        //   name: "View Google Assistant Action",
        //   url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        // }
      ]
    },
    {
      title: "AWS Training Certification",
      subtitle:
        "Started with DevOps on AWS.",
      image: require("./assets/images/aws-devops.png"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        // {
        //   name: "View Google Assistant Action",
        //   url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        // }
      ]
    },
    {
      title: "Web App Developer",
      subtitle: "Complete Web Developer Bootcamp By Dr Angela Yu from udemy",
      image: require("./assets/images/udemy anjela.PNG"),
      imageAlt: "PWA Logo",
      footerLink: [
        
      ]
    },

  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
    
  number: "+94 705901816",
  email_address: "sanjusooriyaarachchi@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "SanjuChandima", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
